import { DataService } from 'src/app/dashboards/services/data.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EntityTypes } from '../../enums/entity-types';
import { AppModalComponent } from '../app-modal/app-modal.component';
import { ModalConfig } from '../../models/modal.config';
import { ModalConfigHelper } from '../../helpers/modal-config-helper';
import { Observable, from, map, of } from 'rxjs';
import { ReportRequestDto } from '../../models/requests/report.request';
import { UiStateStore } from '../../store/ui-state-store.service';

@Component({
  selector: 'app-report-as-malicious',
  templateUrl: './report-as-malicious.component.html',
  styleUrls: ['./report-as-malicious.component.scss']
})
export class ReportAsMaliciousComponent implements OnInit {
  @Input() buttonText: string;
  @Input() recordIdToReport: string;
  @Input() recordTypeToReport: EntityTypes;

  @ViewChild("reportModal") private modalComponent: AppModalComponent;
  modalConfig: ModalConfig;
  reasonOfReporting: string;

  constructor(private dataService: DataService,
    private uiState: UiStateStore) {
    this.modalConfig = ModalConfigHelper.getReportModalConfig( this.onDismiss, this.onClose);
   }

  ngOnInit(): void {
  }

  handleReportClick = () => {
    console.log(this.recordIdToReport);
    this.modalComponent.open();
  }

  private onClose = async (): Promise<Observable<boolean>> => {
    const request: ReportRequestDto = {
      recordId: this.recordIdToReport,
      entityType: this.recordTypeToReport,
      reasonOfReporting: this.reasonOfReporting
    }

    console.log(request);

    const recordType = this.recordTypeToReport == EntityTypes.job ? "Job" : "Profile";
    const result = await this.dataService.reportAsMalicious(request).toPromise();

    if(result){
      this.uiState.setSuccess(`This ${recordType} has been reported.`);
    } else {
      this.uiState.setSuccess(`Unable to report this ${recordType}. Please try again.`);
    }

    return of<boolean>(true);
  };

  private onDismiss = (): Observable<boolean> => {
    return of<boolean>(true);
  };

}
